<template>
    <div class="min-h-screen flex items-center justify-center">
      <div class="gap-8">
        <h1 class="text-2xl font-bold text-center">Payment Successful!</h1>
        <p class="text-center">Validating your payment. Please wait...</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Success',
    mounted() {
      const urlParams = new URLSearchParams(window.location.search);
      const sessionId = urlParams.get('session_id');
      console.log('Session ID from URL:', sessionId);

  
      if (!sessionId) {
        alert('Invalid session. Redirecting to homepage.');
        this.$router.push('/');
        return;
      }
  
      // Validate the session and fetch the token
      this.processPayment(sessionId);
    },
    methods: {
      async processPayment(sessionId) {
        try {
          // Step 1: Get the token from the backend
          const tokenResponse = await fetch(
            'https://1dtb961u4e.execute-api.eu-west-2.amazonaws.com/dev/get-token',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ session_id: sessionId }),
            }
          );
  
          if (!tokenResponse.ok) {
            throw new Error('Failed to retrieve token.');
          }
  
          const { token } = await tokenResponse.json();
  
          // Step 2: Validate the token
          const validateResponse = await fetch(
            'https://1dtb961u4e.execute-api.eu-west-2.amazonaws.com/dev/validate-token',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
              },
            }
          );
  
          if (!validateResponse.ok) {
            throw new Error('Token validation failed.');
          }
  
          // Step 3: Save the token and redirect
          localStorage.setItem('authToken', token);
          console.log('JWT token saved:', token);
  
          this.$router.push('/creation');
        } catch (error) {
          console.error('Error processing payment:', error.message);
          alert('There was an issue validating your payment. Please contact support.');
          this.$router.push('/');
        }
      },
    },
  };
  </script>
  